import { render, staticRenderFns } from "./RegisterFarmModal.vue?vue&type=template&id=130afa1d&scoped=true&"
import script from "./RegisterFarmModal.vue?vue&type=script&lang=js&"
export * from "./RegisterFarmModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFarmModal.vue?vue&type=style&index=0&id=130afa1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130afa1d",
  null
  
)

export default component.exports